import { createListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'

export const useSort = createSharedComposable(() => {
    return createListQuery('sort', [
        { label: 'Descending', value: 'desc' as const },
        { label: 'Ascending', value: 'asc' as const },
        { label: 'Alphabetical (default)', value: 'alphabetical' as const }
    ])
})
